import t from '@guestyci/localize/t.macro';

/**
 * MFA-related translations for Okta widget customization.
 * Used by useOktaWidget to customize MFA enrollment screens.
 */
export const getMfaTranslations = () => ({
  sms: {
    subtitle: t('We will use the phone number you enter below to send you a verification code via SMS.'),
    description: t('Get an SMS with a verification code.'),
    setupButton: t('Set up SMS Authentication'),
  },
  email: {
    description: t('Get an email with a verification code.'),
    setupButton: t('Set up Email Authentication'),
  },
  googleAuth: {
    description: t('Use the Google Authenticator app to get a verification code.'),
    setupButton: t('Set up Google Authenticator'),
  },
});
